import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Mail } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const AdminForgotPassword = () => {
  const [username, setUsername] = useState('admin');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await axios.post(`${API}/api/admin/security/forgot-password`, { username });
      setMessage(data.message || 'Check your inbox for the reset link.');
      setSent(true);
    } catch (err) {
      setMessage(err.response?.data?.detail || err.message || 'Something went wrong.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 px-4">
      <div className="w-full max-w-md" data-testid="admin-forgot-page">
        <div className="bg-white rounded-2xl p-8 shadow-xl">
          <div className="text-center mb-6">
            <div className="w-14 h-14 bg-cyan-500 rounded-full mx-auto flex items-center justify-center">
              <Mail className="text-white" size={22} />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mt-4">Reset admin password</h1>
            <p className="text-sm text-slate-500 mt-1">
              We'll email a one-time reset link to the site owner (30-min expiry).
            </p>
          </div>

          {sent ? (
            <div className="text-center space-y-3" data-testid="admin-forgot-success">
              <p className="text-sm text-slate-700">{message}</p>
              <p className="text-xs text-slate-500">
                Didn't see it? Check spam, then try again.
              </p>
              <a
                href="/admin/login"
                className="inline-block text-cyan-600 hover:text-cyan-700 text-sm font-semibold underline"
              >
                ← Back to login
              </a>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label htmlFor="fp-username" className="text-slate-900 font-medium">Username</Label>
                <Input
                  id="fp-username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="mt-2"
                  data-testid="admin-forgot-username"
                />
              </div>
              {message && <p className="text-sm text-red-600">{message}</p>}
              <Button
                type="submit"
                disabled={sending}
                className="w-full bg-cyan-500 hover:bg-cyan-600 text-white py-5 rounded-lg"
                data-testid="admin-forgot-submit"
              >
                {sending ? <Loader2 className="animate-spin mr-2" size={16} /> : null}
                {sending ? 'Sending…' : 'Email me a reset link'}
              </Button>
              <div className="text-center">
                <a href="/admin/login" className="text-xs text-slate-500 hover:text-cyan-600 underline">
                  ← Back to login
                </a>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPassword;
